module.exports = __webpack_public_path__ + "img/Change.88600fb9.svg";